import { Component, Show } from "solid-js";
import { Portal } from "solid-js/web";

interface RecordingConsentDialogProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

const RecordingConsentDialog: Component<RecordingConsentDialogProps> = (
  props
) => {
  return (
    <Show when={props.isOpen}>
      <Portal>
        <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000]">
          <div
            role="dialog"
            aria-modal="true"
            class="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl"
          >
            <h2 class="text-xl font-semibold mb-4">Audio Recording Consent</h2>

            <div class="space-y-4">
              <p class="text-gray-600">
                This session will be audio recorded for accuracy, documentation,
                and compliance purposes.
              </p>

              <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
                <p class="text-sm text-blue-700">The recording will be:</p>
                <ul class="list-disc ml-5 mt-2 text-sm text-blue-600">
                  <li>Stored securely</li>
                  <li>Associated with this session only</li>
                  <li>Used for quality and compliance</li>
                  <li>Handled according to our privacy policy</li>
                </ul>
              </div>

              <p class="text-sm text-gray-500">
                You can proceed without recording, but this may affect
                documentation quality.
              </p>
            </div>

            <div class="mt-6 flex justify-end gap-3">
              <button
                onClick={() => props.onDecline()}
                class="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                Decline
              </button>
              <button
                onClick={() => props.onAccept()}
                class="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Accept & Continue
              </button>
            </div>
          </div>
        </div>
      </Portal>
    </Show>
  );
};

export default RecordingConsentDialog;
